import { BaseWebComponent } from "../base-components/base-web-component.js";

export abstract class LoginBase extends BaseWebComponent {
    protected bindElementValue(element: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement, property: string): void {
        element.addEventListener('input', (event) => {
            const target = event.target as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
            (this as any)[property] = target.value;
        });

    }
}